import React from 'react';

export interface WizardStep {
  label: string;
  icon?: React.ReactNode;
}

interface WizardStepperProps {
  currentStep: number;
  totalSteps: number;
  steps: WizardStep[];
}

const WizardStepper: React.FC<WizardStepperProps> = ({ currentStep, totalSteps, steps }) => {
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-2 flex-1">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = currentStep > stepNumber;
          const isCurrent = currentStep === stepNumber;
          const isActive = currentStep >= stepNumber;

          return (
            <React.Fragment key={index}>
              <div className={`flex items-center gap-2 ${isActive ? 'text-primary' : 'text-muted-foreground'}`}>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${isActive ? 'bg-primary text-primary-foreground' : 'bg-muted'}`}>
                  {isCompleted ? '✓' : stepNumber}
                </div>
                <span className="hidden sm:inline">{step.label}</span>
              </div>
              {index < steps.length - 1 && <div className="flex-1 h-px bg-border" />}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default WizardStepper;

